<section class="bg-background flex items-center justify-center h-screen w-full">
  <div class="h-screen bg-cover bg-center bg-no-repeat hidden sm:block w-full">
    <img
      appProgressiveImage
      lowSrc="/assets/images/cover.webp"
      src="/assets/images/cover.jpg"
      alt="Cover"
      class="w-full h-full"
      style="object-fit: cover"
      loading="lazy"
    />
  </div>
  <div
    class="p-4 xs:p-5 xs:m-10 md:p-8 md:m-16 min-w-[320px] xs:min-w-[360px] md:min-w-[420px] xl:min-w-[500px] bg-white shadow rounded-lg"
  >
    <div class="h-full flex flex-col items-center justify-center gap-6">
      <img src="assets/images/logo.svg" alt="Logo" />
      <div class="w-full">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</section>
